"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dnd_core_1 = require("dnd-core");
exports.XYCoord = dnd_core_1.XYCoord;
/**
 * Top-Level API
 */
/*
export type DropTargetDecorator<P> = (
    types: Identifier | Identifier[] | ((props: P) => Identifier | Identifier[]),
    spec: DropTargetSpec<P, any>,
    collect: DropTargetCollector<any>,
    options?: DndOptions<P>,
) => (
    componentClass: React.ComponentClass<P> | React.StatelessComponent<P>,
) => DndComponentClass<P>

export type DragSourceDecorator<P> = (
    type: Identifier | ((props: P) => Identifier),
    spec: DragSourceSpec<P, any, any>,
    collect: DragSourceCollector<any>,
    options?: DndOptions<P>,
) => (
    componentClass: React.ComponentClass<P> | React.StatelessComponent<P>,
) => DndComponentClass<P>

export type DragLayerDecorator<P> = (
    collect: DragLayerCollector<P, any>,
    options?: DndOptions<P>,
) => (
    componentClass: React.ComponentClass<P> | React.StatelessComponent<P>,
) => DndComponentClass<P>
*/
//# sourceMappingURL=interfaces.js.map